export default "__VITE_ASSET__BRd1k4bQ__"